export default __webpack_public_path__ + "static/GothamNarrowBold-ea2d0d33acf99d51bc195dbd1281f5dd.eot";